
import {
    differenceInDays
} from 'date-fns';

export default {
    data() {
        return {
            defaultImg: require('@/assets/img/icon/default.png'),
            imgOnError: `this.onerror=''; src='${require('@/assets/img/icon-default.png')}'`,
            countRenew: {
                api: 0,
                http: 0,
                kafka: 0,
                module: 0,
                mqtt: 0,
                count: 0
            },
            enumRenew: {
                OPENAPI: 1, // 标准接口
                CUSTOM_API: 2, // 定制接口
                PUSH_MQTT: 3, // MQTT推送
                PUSH_HTTP: 4, // HTTP推送
                PUSH_KAFKA: 5, // KAFKA推送
                PROJECT: 92, // 定制接口分类
            },
            coverNum_: {
                1: 'api',
                3: 'mqtt',
                4: 'http',
                5: 'kafka',
                92: 'module',
            }
        };
    },
    computed: {
        showRenew() {
            return this.$store.state.showRenew;
        }
    },
    methods: {
        updateState(payload = {}) {
            Object.assign(this.$data, payload);
        },
        async post(url, data, key, config) {
            if (key) this.updateState({ [key]: true });

            try {
                const result = await this.$http.post(url, data, config);

                return result;
            } catch (e) {
                throw e;
            } finally {
                if (key) this.updateState({ [key]: false });
            }
        },
        async get(url, data, key, config) {
            if (key) this.updateState({ [key]: true });

            try {
                const result = await this.$http.get(url, data, config);

                return result;
            } catch (e) {
                throw e;
            } finally {
                if (key) this.updateState({ [key]: false });
            }
        },
        async _getU() {
            return await this.$store.dispatch('getU');
        },
        _checkModuleName(item) {
            const u = this.$store.state.userInfo;
            // 判断财运通用户 对应的分类 不是财运通 不可申请
            if (u && u.source === 'cyt' && !(item.moduleName || '').includes('财运通')) {
                return 2;
                // 判断G7s用户 对应的分类 是财运通 不可申请
            } else if (u && u.source !== 'cyt' && (item.moduleName || '').includes('财运通')) {
                return 1;
            }
            return 0;// 可以申请
        },
        _getAcc(v) {
            if (!v) {
                const u = this.$store.state.userInfo;
                if (u) {
                    v = u.source === 'cyt' ? 2 : 1;
                }
            }
            return { 1: 'G7统一账号', 2: '财运通账号' }[v];
        },
        differenceInDays(time, end) {
            // 时间相差多少天
            if (!time) return false;
            const date = end || new Date();
            const day = differenceInDays(time, this.$pub.formatDate(date, 'YYYY-MM-DD'));
            return day;
        },
        async _renewalCount() {
            // 统计各订阅服务到期数量
            const r = await this.$http.get('v1/openapi-web/renewal/count');
            let count = 0;
            for (const k in r) {
                count += r[k];
            }
            this.countRenew = {
                ...r,
                count
            };
        },
        async _renewalTypeCount(dataType) {
            const r = await this.$http.get('v1/openapi-web/renewal/count_type', { dataType });
            if (r) {
                this.countRenew[this.coverNum_[dataType]] = r[this.coverNum_[dataType]] || 0;
            } else {
                this.countRenew[this.coverNum_[dataType]] = 0;
            }
        },
        _countRenewClose(dataType) {
            this.showRenew[this.coverNum_[dataType]] = false;
            this.$store.commit('updateShowRenew', this.showRenew);
        },
        _disableAndenable(r, dataType) {
            const uri = `v1/openapi-web/user_access_handle/${this.coverNum_[dataType]}`;
            const data = {
                id: r.id,
                state: r.userAccessState == 1 ? 2 : 1,
            };
            if (r.userAccessState == 1) { // 禁用
                this.$prompt('请输入禁用原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^.{2,50}$/,
                    inputErrorMessage: '请输入长度2-50的禁用原因',
                    inputType: 'textarea'
                }).then(async ({ value }) => {
                    data.disableReason = value;
                    await this.$http.post(uri, data, {
                        contentType: 'json',
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8'
                        }
                    });
                    this.refresh();
                    this.$_message({
                        type: 'success',
                        message: '操作成功!'
                    });
                }).catch(() => {
                });
            } else {
                this.$confirm('确认启用服务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await this.$http.post(uri, data, {
                        contentType: 'json',
                        headers: {
                            'Content-Type': 'application/json; charset=utf-8'
                        }
                    });
                    this.refresh();
                    this.$_message({
                        type: 'success',
                        message: '操作成功!'
                    });
                }).catch(() => {
                });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/configs/mixins.js